export default "__VITE_ASSET__B7HBo6AK__"